<script lang="ts">
    import { generateScriptString } from './functions';
    import type { JsonLdData } from './types';

    export let data: JsonLdData | null | undefined = null;

    let jsonLdString: string | null;
    $: jsonLdString = data
        ? JSON.stringify({
            '@context': 'https://schema.org',
            ...data,
        })
        : null;

</script>

<svelte:head>
    {#if jsonLdString}
        {@html generateScriptString(jsonLdString)}
    {/if}
</svelte:head>
